import axios from 'axios'
import axiosJsonpAdapter from 'axios-jsonp'
import Store from '@/store/index.js'

export default {
  namespaced: true,
  actions: {
    request(
      { dispatch, rootState },
      { method, url, params, headers, error, isAdapter }
    ) {
      const req = {
        method,
        url: `${process.env.API.DOMAIN}${url}`,
      }

      if (headers) {
        req.headers = headers
      } else if (Store.state.auth.ACCESS_TOKEN) {
        req.headers = {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        }
      }

      // getとそれ以外でパラメータ名を変更
      if (method === 'get') {
        req.params = params
      } else {
        req.data = params
      }

      return axios(req).catch((err) => {
        if (err.response.status === 403) location.href = '/logout'
        let message = ''
        if (error && error.message) {
          message = error.message
        } else {
          message = err.response.data || err.message
        }
        throw new Error(message)
      })
    },
    get({ dispatch }, requests) {
      requests.method = 'get'
      return dispatch('request', requests)
    },
    post({ dispatch }, requests) {
      requests.method = 'post'
      return dispatch('request', requests)
    },
    put({ dispatch }, requests) {
      requests.method = 'put'
      return dispatch('request', requests)
    },
    delete({ dispatch }, requests) {
      requests.method = 'delete'
      return dispatch('request', requests)
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/http.js